// Thin v1 API client for the RSA Operations section embedded in the legacy admin
// dashboard (pages/admin/Rsa/*). Deliberately reuses the legacy admin session's
// `access_tokenSP` (set by pages/login on /admin sign-in) rather than a second
// RSA-specific login: the legacy admin controller signs its JWT with the same
// hardcoded fallback secret v1's requireAuth middleware uses when JWT_SECRET isn't
// set (true in this env's docker-compose), and both carry `role: "admin"` — so one
// admin sign-in is enough for both surfaces here. If that ever stops holding (e.g.
// JWT_SECRET diverges in another environment), calls below 401 and the screen shows
// a re-auth prompt rather than silently failing.
const BASE = (process.env.REACT_APP_BASE_URL || "http://localhost:3008") + "/api/v1";

export async function adminApi(method, path, body) {
  const token = localStorage.getItem("access_tokenSP");
  const res = await fetch(BASE + path, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = { raw: text }; }
  if (!res.ok) {
    const err = new Error(data?.detail || data?.title || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}
